<template>
    <v-card flat class="pa-4" v-if="!isPlatformLoading && success">
        <v-card-text style="position:relative;">
            <div :style="{top:(height - 10)+'px'}" class="report-hidden-bar"></div>
            <iframe
                    allowfullscreen="false"
                    frameborder="0"
                    :height="height"
                    :src="url"
                    width="100%"
            >
            </iframe>
        </v-card-text>
    </v-card>
    <AudienceNotAvailable v-else-if="!isPlatformLoading && !success">
        <template v-slot:title>
            Start monitoring your brand {{ platform === 'forum' ? "inside" : "on" }} <span class="text-capitalize">{{ platformName[platform] || platform }}!</span>
        </template>
        <template v-slot:media>
            <v-img
                    :src="require('@/assets/Platform.svg')"
                    height="200"
                    style="margin:0 auto;"
                    width="300"
            >
            </v-img>
        </template>
    </AudienceNotAvailable>
    <div class="text-xs-center" v-else>
        <Spinner/>
        <span class="font-weight-bold display-1 description--color">Loading...</span>
    </div>
</template>

<script>
    import {mapActions, mapState} from 'vuex';
    import Spinner from '@/components/Spinner';

	export default {

		name: "Platform",
		components: {
			Spinner,
			AudienceNotAvailable: () => import(/*webpackChunkName:"AudienceNotAvailable"*/"../components/Audience/AudienceNotAvailable")
		},
        props:{
			monitor_uuid:{
				required: true,
                type: String,
            },
            platform:{
				required: true,
                type: String,
            }
        },

        data(){
			return{
				isPlatformLoading: false,
                platformName:{tiktok:"TikTok", forum:"Forums"},
			}
        },

		computed: {
			...mapState('platform', [
				"success",
                "url",
                "height",
			])
		},

		created() {
			this.isPlatformLoading = true;
			this.getPlatformInfo({monitor_uuid: this.monitor_uuid, platform: this.platform})
				.finally(_ => {
					this.isPlatformLoading = false;
				})
		},

        methods:{
			...mapActions('platform',[
				"getPlatformInfo"
            ])
        },

	}
</script>

<style scoped>
    .report-hidden-bar {
        position: absolute;
        width: 100%;
        height: 30px;
        background-color: #fff;
    }
</style>
